<template>
  <a-modal width="550px" :visible="visible" title="Refuse to Sign Written Warning" @cancel="closeModal">
    <signature
      key="confirmSignature"
      checkbox-label="I have reviewed and verified all staffing assignments are true and accurate. Employees not captured in payroll records, nurse assistants or employees who are primarily engaged in duties other than nursing services that provided nursing services during the patient day are recorded and their direct care service hours to be included in Direct Care Service Hours Per Patient Day are accounted for with an original signature."
      ref="signatureRef"
      @checked="checked = $event"
      @save-signature="setSignatureId"
    />

    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="closeModal">Close</a-button>
        <a-button type="primary" :disabled="!checked" :loading="loading" @click="sign"> Sign </a-button>
      </div></template
    >
  </a-modal>
</template>

<script>
import Signature from '@/components/signature.vue'
import { Button, Modal, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapState: shiftState, mapActions: shiftActions } = createNamespacedHelpers('shifts')

export default {
  components: {
    'a-modal': Modal,
    'a-button': Button,
    Signature
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    conformation_id: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      signature_id: undefined,

      checked: false,

      loading: false
    }
  },
  computed: {
    ...shiftState({
      shift: state => state.shift.shift
    })
  },
  methods: {
    ...shiftActions(['postSignDigitalCDPH']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    closeModal() {
      this.checked = false
      this.signature_id = undefined
      this.$emit('update:visible', false)
      this.$emit('update:conformation_id', undefined)
    },

    setSignatureId(signatureId) {
      this.signature_id = signatureId
    },

    async sign() {
      this.loading = true

      try {
        await this.$refs.signatureRef.saveSignature()

        const payload = {
          signature_id: this.signature_id,
          shift_id: this.shift.id
        }

        await this.postSignDigitalCDPH(payload)

        this.showNotification('success', 'Success', 'Digital CDPH 530 Signed Successfully')

        this.$emit('update')
        this.closeModal()
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
